export const TEMPLATE_TAPJOY_BID_UPDATE = 'tapjoyBidUpdateTemplate';

export const SOCKET_EVENT_STATUS_CHANGE = 'change-status';
export const SOCKET_EVENT_API_PERMISSION_CHANGE = 'change-api-permission';

export const STATUS_NOT_STARTED = 0;
export const STATUS_RUNNING = 1;
export const STATUS_COMPLETED = 2;
export const STATUS_COMPLETED_WITH_ERRORS = 3;
export const STATUS_FAILED = 4;
export const STATUS_CANCELED = 5;
